import { z } from 'zod'

export const sistemaFormSchema = z.object({
  nome: z.string().min(1, 'Nome é obrigatório').max(255, 'Nome deve ter no máximo 255 caracteres'),
  descricao: z.string().min(1, 'Descrição é obrigatória'),
  categoria: z.enum(['Software de Negócio', 'Banco de Dados', 'Sistema Operacional', 'Web'] as const, {
    message: 'Categoria é obrigatória',
  }),
  versao_atual: z.string().min(1, 'Versão atual é obrigatória').max(255),
  proprietario_fk: z.string().min(1, 'Setor proprietário é obrigatório'),
  gestor_tecnico_fk: z.string().min(1, 'Gestor técnico é obrigatório'),
  status_ciclo_vida: z.string().min(1, 'Status do ciclo de vida é obrigatório'),
  fornecedor: z.string().min(1, 'Fornecedor é obrigatório'),
  tipo_licenca: z.string().min(1, 'Tipo de licença é obrigatório'),
  quantidade_licencas: z.string().min(1, 'Quantidade de licenças é obrigatória'),
  data_expiracao: z.string().optional(),
  data_renovacao: z.string().optional(),
  custo_anual: z.string().min(1, 'Custo anual é obrigatório'),
  servidores_infraestrutura: z.string().min(1, 'Servidores/infraestrutura é obrigatório'),
  servico_negocio_relacionado: z.string().min(1, 'Serviço de negócio relacionado é obrigatório'),
  documentacao_link: z.string().optional(),
  suporte_dr: z.string().min(1, 'Suporte DR é obrigatório'),
  suporte_dn: z.string().min(1, 'Suporte DN é obrigatório'),
  suporte_fornecedor: z.string().min(1, 'Suporte fornecedor é obrigatório'),
})

export type SistemaFormValues = z.infer<typeof sistemaFormSchema>
